import { VendorOnboarding } from '../components/VendorOnboarding'

export function OnboardingPage() {
  return <VendorOnboarding />
}
